import CreateOrEditPatient from './CreateOrEditPatient'
import CreateOrEditMessages from './CreateOrEditMessages'
import CreateOrEditRestriction from './CreateOrEditRestriction'
import CreateOrEditShift from './CreateOrEditShift'
import CreateOrEditServiceTime from './CreateOrEditServiceTime'
import CreateOrEditServiceRegion from './CreateOrEditServiceRegion'
import CreateOrEditServiceArea from './CreateOrEditServiceArea'
import CreateOrEditOpenTime from './CreateOrEditOpenTime'
import CreateOrEditWaitList from './CreateOrEditWaitList'
import CreateOrEditWaitListMessage from './CreateOrEditWaitListMessage'
import RestrictionForm from './RestrictionForm'
import RepeatingForm from './RepeatingForm'
import CreateOrEditAppointment from './CreateOrEditAppointment'
import CreateOrEditAdministrator from './CreateOrEditAdministrator'
import CreateOrEditAppointmentTypeDurations from './CreateOrEditAppointmentTypeDurations'
import CreateOrganization from './CreateOrganization'
import PatientForm from './PatientForm'
import AccountForm from './AccountForm'
import AppointmentTypeForm from './AppointmentTypeForm'
import WidgetCustomFields from './WidgetCustomFields'
import WidgetSuperAdmin from './WidgetSuperAdmin'
import WidgetAppointmentTypes from './WidgetAppointmentTypes'
import WidgetAdministrators from './WidgetAdministrators'
import WidgetCodeSnippet from './WidgetCodeSnippet'
import WidgetSpeciesAndBreed from './WidgetSpeciesAndBreed'
import WidgetGenderChange from './WidgetGenderChange'
import WidgetAppointments from './WidgetAppointments'
import SelectRestriction from './SelectRestriction'
import SexesForm from './SexesForm'
import BreedForm from './BreedForm'
import SpeciesForm from './SpeciesForm'
import CreateOrEditWaitingRoom from './CreateOrEditWaitingRoom'
import WidgetAdvancedFields from './WidgetAdvancedFields'
import NotesWidget from './NotesWidget'

export {
    AccountForm,
    AppointmentTypeForm,
    BreedForm,
    CreateOrEditRestriction,
    CreateOrEditAppointment,
    CreateOrEditPatient,
    CreateOrEditMessages,
    CreateOrEditShift,
    CreateOrEditServiceTime,
    CreateOrEditOpenTime,
    CreateOrEditAdministrator,
    CreateOrEditAppointmentTypeDurations,
    CreateOrEditServiceRegion,
    CreateOrEditServiceArea,
    CreateOrEditWaitList,
    CreateOrEditWaitListMessage,
    CreateOrEditWaitingRoom,
    CreateOrganization,
    PatientForm,
    RepeatingForm,
    RestrictionForm,
    SelectRestriction,
    SexesForm,
    SpeciesForm,
    WidgetAdministrators,
    WidgetAppointments,
    WidgetAppointmentTypes,
    WidgetAdvancedFields,
    WidgetCodeSnippet,
    WidgetCustomFields,
    WidgetGenderChange,
    WidgetSpeciesAndBreed,
    WidgetSuperAdmin,
    NotesWidget
}


// WEBPACK FOOTER //
// ./src/components/partials/index.js